"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiastereotopicAtomIDs = void 0;
const getSymmetryRanks_1 = require("../util/getSymmetryRanks");
const makeRacemic_1 = require("../util/makeRacemic");
const tagAtom_1 = require("../util/tagAtom");
const ensureHeterotopicChiralBonds_1 = require("./ensureHeterotopicChiralBonds");
/**
 * Returns an array of diastereotopic ID (as idCode)
 * @param {import('openchemlib').Molecule} molecule
 */
function getDiastereotopicAtomIDs(molecule) {
    const { Molecule } = molecule.getOCL();
    (0, ensureHeterotopicChiralBonds_1.ensureHeterotopicChiralBonds)(molecule);
    const symmetryRanks = (0, getSymmetryRanks_1.getSymmetryRanks)(molecule);
    const numberAtoms = molecule.getAllAtoms();
    const ids = [];
    const cache = {};
    for (let iAtom = 0; iAtom < numberAtoms; iAtom++) {
        const rank = symmetryRanks[iAtom];
        if (rank && cache[rank]) {
            ids[iAtom] = cache[rank];
            continue;
        }
        const tempMolecule = molecule.getCompactCopy();
        (0, tagAtom_1.tagAtom)(tempMolecule, iAtom);
        (0, makeRacemic_1.makeRacemic)(tempMolecule);
        // We need to ensure the helper array in order to get correctly the result of racemisation
        ids[iAtom] = tempMolecule.getCanonizedIDCode(Molecule.CANONIZER_ENCODE_ATOM_CUSTOM_LABELS);
        cache[rank] = ids[iAtom];
    }
    return ids;
}
exports.getDiastereotopicAtomIDs = getDiastereotopicAtomIDs;
//# sourceMappingURL=getDiastereotopicAtomIDs.js.map